import { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import { useIsMobile } from '../../../../utils/getIsMobile';
import { getWindow } from '../../../../utils/getWindow';
import { ONBOARDING_STORAGE_KEY } from '../constants';

const THROTTLE_DELAY = 100;

export const useScrollDetection = () => {
    const isMobile = useIsMobile();

    const [hasScrolled, setHasScrolled] = useState<boolean>(() => {
        const window = getWindow();
        if (!window) {
            return false;
        }

        return Boolean(window.localStorage.getItem(ONBOARDING_STORAGE_KEY));
    });

    useEffect(() => {
        const window = getWindow();
        if (!isMobile || hasScrolled || !window) {
            return;
        }

        const handleScroll = throttle(() => {
            setHasScrolled(true);
            window.localStorage.setItem(ONBOARDING_STORAGE_KEY, '1');
        }, THROTTLE_DELAY);

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            handleScroll.cancel();
        };
    }, [isMobile, hasScrolled]);

    return hasScrolled;
};
